import * as React from "react"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import fonts from "@digits-shared/themes/typography"
import { styled } from "styled-components"
import { usePasswordReset } from "src/frontend/components/Public/LogIn/Glow/usePasswordReset"
import { useOnboardingContext } from "src/frontend/components/Public/Onboarding/OnboardingContext"
import { Header } from "src/frontend/components/Shared/Glow/Header"

const Body = styled.div`
  font-size: 12px;
`

const Bold = styled.span`
  font-weight: ${fonts.weight.heavy};
`

export const ForgotPassword: React.FC = () => {
  const {
    state: { loading, emailAddress },
  } = useOnboardingContext()

  const onResetCompleted = useOnResetCompleted()
  const onResetPasswordClick = usePasswordReset(onResetCompleted)
  const onBack = useBack()

  return (
    <>
      <Header onBack={onBack} disabled={loading}>
        Forgot Password?
      </Header>
      <Body>
        We will send an email link to <Bold>{emailAddress}</Bold> to reset your password.
      </Body>
      <DigitsButton
        $fullWidth
        id="reset-password-button"
        disabled={loading}
        onClick={onResetPasswordClick}
        label="Reset Password"
      />
    </>
  )
}

function useOnResetCompleted() {
  const { dispatch } = useOnboardingContext()
  return React.useCallback(() => {
    dispatch({ type: "SHOW_PASSWORD_RESET_SENT" })
  }, [dispatch])
}

function useBack() {
  const {
    state: { emailAddress },
    dispatch,
  } = useOnboardingContext()

  return React.useCallback(() => {
    dispatch({ type: "SHOW_EMAIL_SIGN_IN", emailAddress })
    dispatch({ type: "BACK" })
  }, [dispatch, emailAddress])
}
